import { type PageTemplate, type Template } from '@databases/types/confluence';

import { nextPagination } from '../pagination.ts';

import { fetchConfluenceData, rejectOnError } from './fetch.ts';

/**
 * Returns page templates (defined by global/space admins). If the spaceKey is defined, only the page templates in the given
 * space are returned (global templates are not included). If the spaceKey is undefined, only global templates are returned.
 */
export function getPageTemplates(
  spaceKey?: string,
  expand: string[] = []
): AsyncGenerator<PageTemplate, void, void> {
  return nextPagination<PageTemplate>(async (url) => {
    const res = await fetchConfluenceData(
      url ??
        `/rest/api/template/page?${new URLSearchParams({
          ...(spaceKey ? { spaceKey } : {}),
          expand: expand.join(','),
          limit: '200'
        })}`
    ).then(rejectOnError);
    return await res.json();
  });
}

/**
 * Returns all space page templates, global page templates and blueprints that are available in the given space.
 */
export async function* getAllTemplates(
  spaceKey: string,
  expand: string[] = []
): AsyncGenerator<Template, void, void> {
  const spacePageTemplates = getPageTemplates(spaceKey, expand);
  const globalPageTemplates = getPageTemplates(undefined, expand);

  for await (const template of spacePageTemplates) {
    yield template;
  }

  for await (const template of globalPageTemplates) {
    yield template;
  }
}
